import React from "react";
import Link from "next/link";
import { BiPhone, BiEnvelope, BiLogoLinkedin, BiRocket, BiCheckCircle, BiLineChart, BiCog, BiShield, BiTargetLock, BiTrendingUp, BiData, BiChart } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';

const BusinessAnalyticsInfoAndCTA = () => {
  const { t } = useTranslations();

  const features1 = [
    { icon: BiLineChart, text: t("businessAnalytics_infoAndCTA_feature1") },
    { icon: BiCog, text: t("businessAnalytics_infoAndCTA_feature2") },
    { icon: BiShield, text: t("businessAnalytics_infoAndCTA_feature3") },
    { icon: BiTargetLock, text: t("businessAnalytics_infoAndCTA_feature4") },
  ];

  const features2 = [
    { icon: BiTrendingUp, text: t("businessAnalytics_infoAndCTA_feature5") },
    { icon: BiData, text: t("businessAnalytics_infoAndCTA_feature6") },
    { icon: BiChart, text: t("businessAnalytics_infoAndCTA_feature7") },
    { icon: BiCheckCircle, text: t("businessAnalytics_infoAndCTA_feature8") },
  ];

  return (
    <section className="ba-info-cta">
      {/* Dekorationen */}
      <div className="ba-info-cta__decoration ba-info-cta__decoration--1"></div>
      <div className="ba-info-cta__decoration ba-info-cta__decoration--2"></div>

      <div className="container">
        {/* Erste Sektion */}
        <FadeInAnimation direction="up" delay={100}>
          <div className="ba-info-cta__section">
            <div className="ba-info-cta__header">
              <h2 className="ba-info-cta__title">
                {t("businessAnalytics_infoAndCTA_title")}
              </h2>
              <div className="ba-info-cta__title-line"></div>
            </div>

            <p className="ba-info-cta__description">
              {t("businessAnalytics_infoAndCTA_description")}
            </p>

            <div className="ba-info-cta__features-grid">
              {features1.map((feature, index) => (
                <FadeInAnimation key={index} direction="up" delay={150 + index * 50}>
                  <div className="ba-info-cta__feature-card">
                    <div className="ba-info-cta__feature-icon">
                      <feature.icon />
                    </div>
                    <span className="ba-info-cta__feature-text">{feature.text}</span>
                  </div>
                </FadeInAnimation>
              ))}
            </div>
          </div>
        </FadeInAnimation>

        {/* Zweite Sektion */}
        <FadeInAnimation direction="up" delay={200}>
          <div className="ba-info-cta__section ba-info-cta__section--highlight">
            <div className="ba-info-cta__header">
              <h3 className="ba-info-cta__subtitle">
                {t("businessAnalytics_infoAndCTA_title2")}
              </h3>
            </div>

            <p className="ba-info-cta__description">
              {t("businessAnalytics_infoAndCTA_description2")}
            </p>

            <div className="ba-info-cta__features-grid">
              {features2.map((feature, index) => (
                <FadeInAnimation key={index} direction="up" delay={250 + index * 50}>
                  <div className="ba-info-cta__feature-card ba-info-cta__feature-card--alt">
                    <div className="ba-info-cta__feature-icon ba-info-cta__feature-icon--alt">
                      <feature.icon />
                    </div>
                    <span className="ba-info-cta__feature-text">{feature.text}</span>
                  </div>
                </FadeInAnimation>
              ))}
            </div>

            <div className="ba-info-cta__button-wrapper">
              <Link href="/kontakt" className="ba-info-cta__button">
                <BiRocket />
                <span>{t("businessAnalytics_infoAndCTA_button")}</span>
              </Link>
            </div>
          </div>
        </FadeInAnimation>

        {/* CTA Sektion */}
        <FadeInAnimation direction="up" delay={300}>
          <div className="ba-info-cta__cta-box">
            <div className="ba-info-cta__cta-content">
              <div className="ba-info-cta__cta-text">
                <h4 className="ba-info-cta__cta-title">
                  {t("businessAnalytics_infoAndCTA_title3")}
                </h4>
                <p className="ba-info-cta__cta-description">
                  {t("businessAnalytics_infoAndCTA_description3")}
                </p>
              </div>

              <div className="ba-info-cta__cta-actions">
                <div className="ba-info-cta__contact-label">
                  {t("businessAnalytics_infoAndCTA_contact")}
                </div>
                <div className="ba-info-cta__social-links">
                  <a href="tel://+4943170577024" className="ba-info-cta__social-link" aria-label="Telefon">
                    <BiPhone />
                  </a>
                  <a href="mailto:info@simplify-data.de" className="ba-info-cta__social-link" aria-label="E-Mail">
                    <BiEnvelope />
                  </a>
                  <a href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank" rel="noopener noreferrer" className="ba-info-cta__social-link" aria-label="LinkedIn">
                    <BiLogoLinkedin />
                  </a>
                </div>
                <Link href="/kontakt" className="ba-info-cta__button ba-info-cta__button--secondary">
                  <span>{t("businessAnalytics_infoAndCTA_button2")}</span>
                </Link>
              </div>
            </div>
          </div>
        </FadeInAnimation>
      </div>
    </section>
  );
};

export default BusinessAnalyticsInfoAndCTA;
